const lightningSlickSVG = `

<svg width="25" height="30" viewBox="0 0 25 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<g filter="url(#filter0_d_2342_64)">
<path d="M17 10.6082H13.8L15.4 4L9 14.3918H12.2L10.6 21L17 10.6082Z" fill="#08FCC9"/>
<path d="M17 10.6082H13.8L15.4 4L9 14.3918H12.2L10.6 21L17 10.6082Z" stroke="#08FCC9" stroke-linejoin="round"/>
</g>
<defs>
<filter id="filter0_d_2342_64" x="4.5" y="3.5" width="17" height="26" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
<feFlood flood-opacity="0" result="BackgroundImageFix"/>
<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
<feOffset dy="4"/>
<feGaussianBlur stdDeviation="2"/>
<feComposite in2="hardAlpha" operator="out"/>
<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"/>
<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2342_64"/>
<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2342_64" result="shape"/>
</filter>
</defs>
</svg>

`

export default lightningSlickSVG;



// WEBPACK FOOTER //
// ./src/Components/inlineSVGs/lightningSlickSVG.js